<template>
    <div class="el-Aitools" v-loading="loading" element-loading-text="Loading..." :element-loading-spinner="svg"
        element-loading-svg-view-box="-10, -10, 50, 50" element-loading-background="rgba(122, 122, 122, 0.8)">
        <iframe id="iframe" src="https://dshlw.sztzjy.com:165" width="100%" height="100%" frameborder="1"></iframe>
    </div>
</template>
<script>
export default {
    name: "",
    data() {
        return {
            loading: true
        }
    },
    created() { },
    mounted() {
        // 原始路径https://ai-bot.cn/
        setTimeout(() => {
            this.loading = false
        }, 2000)
    },
    computed: {},
    methods: {}
}
</script>
<style lang="less" scoped>
.el-Aitools {
    position: relative;
    padding: 20px 20px 0;
    min-height: calc(100vh - 95px);

    #iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/AiTools.vue